import { useState } from "react";
import AssignmentModal from "../modal/AssignmentModal";
import { useGetAssignmentByVideoIdQuery } from "../../../features/assignment/assignmentApi";

export default function AssignmentButton({ videoId }) {
	const {
		data: assignments,
		isSuccess,
		isError,
	} = useGetAssignmentByVideoIdQuery(videoId) || {};

	const [isOpen, setIsOpen] = useState(false);

	if (isSuccess && assignments?.length > 0) {
		return (
			<>
				<button
					onClick={() => setIsOpen(true)}
					className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
				>
					এসাইনমেন্ট
				</button>
				{isOpen && (
					<AssignmentModal
						assignment={assignments[0]}
						isOpen={isOpen}
						onClose={setIsOpen}
					/>
				)}
			</>
		);
	}

	if (isError) {
		return null;
	}
}
